module.exports = __webpack_public_path__ + "img/map_1791448112229_40700.211f4080.png";